// Lightweight URL-based referral tracking. We capture `?ref=` on landing
// and persist it for up to 30 days so users can browse around, then sign
// up later, and the referrer still gets credit.
const REF_KEY = 'fnl_ref';
const REF_EXP_MS = 30 * 24 * 3600 * 1000; // 30 days

export const captureRefFromUrl = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (!ref) return;
    const sanitized = ref.toLowerCase().replace(/[^a-f0-9-]/g, '').slice(0, 32);
    if (!sanitized) return;
    localStorage.setItem(REF_KEY, JSON.stringify({
      ref: sanitized,
      ts: Date.now(),
    }));
  } catch (err) {
    console.debug('captureRefFromUrl failed:', err?.message);
  }
};

export const readStoredRef = () => {
  try {
    const raw = localStorage.getItem(REF_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.ref || !parsed?.ts) return null;
    if (Date.now() - parsed.ts > REF_EXP_MS) {
      localStorage.removeItem(REF_KEY);
      return null;
    }
    return parsed.ref;
  } catch (err) {
    return null;
  }
};

export const clearStoredRef = () => {
  try { localStorage.removeItem(REF_KEY); } catch (_) {}
};
